import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
const API_KEY = 'EDK-CA-2026-PROD-1234';
const HEADERS = { 'X-API-Key': API_KEY };

export async function listArticles({ skip = 0, limit = 12, date_filter = 'all', keywords = [], years, months, read_filter } = {}) {
  const params = { skip, limit, date_filter };
  if (read_filter && read_filter !== 'all') params.read_filter = read_filter;
  const res = await axios.post(
    `${BASE_URL}public/current-affairs/list`,
    { keywords, years, months },
    { params, headers: HEADERS }
  );
  return res.data;
}

export async function getArticle(id) {
  const res = await axios.get(`${BASE_URL}public/current-affairs/${id}`, { headers: HEADERS });
  return res.data;
}

export async function searchArticles(keywords, numOfResults = 3) {
  const res = await axios.post(
    `${BASE_URL}public/current-affairs/search_rag?num_of_results=${numOfResults}`,
    { keywords },
    { headers: HEADERS }
  );
  return res.data;
}
